module.exports = __webpack_public_path__ + "img/type--1-spans--multiple-lang--es.5d2bfd4a.jpg";